import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { GoodItem } from "pages/shipper/ShipmentQuotes/components/quotes/QuotesType";
import { IGoodCustomInfo } from "pages/shipper/RequestForm/components/PackingList/Types";
import { formatNumberV2 } from "helpers/commonHelpers";
import { calculateGoodItemsTotalWeight } from "helpers/quotationFormHelper";
import { WeightUnitTypes } from "constants/";

function QuotesDetailTab({ quoteDetailData }: { quoteDetailData: any }) {
  const { service } = quoteDetailData || {};
  const { good_items } = quoteDetailData?.organization || {};

  // Total weight of goods converted to a common unit (kg)
  const { weight: totalWeight } = calculateGoodItemsTotalWeight(good_items, WeightUnitTypes.KG);

  // Total value of custom goods
  const totalCustomValue = good_items?.reduce(
    (total: GoodItem, item: GoodItem) =>
      total +
      item.good_customs_information.reduce((subtotal: IGoodCustomInfo, customsInfo: any) => subtotal + customsInfo.value, 0),
    0,
  );

  // Custom goods currency code
  const currencyCode = good_items && good_items[0]?.good_customs_information[0]?.currency_code;
  const formattedTotalWeight = totalWeight
    ? formatNumberV2(totalWeight, { minimumFractionDigits: 2, maximumFractionDigits: 4 })
    : "-";

  return (
    <div>
      <Row>
        <Col className="text-secondary no-wrap">Custom values</Col>
        <Col className="no-wrap">{`${currencyCode || ""} ${totalCustomValue?.toFixed(2)}`}</Col>
        <Col className="text-secondary no-wrap">Total weight</Col>
        <Col className="no-wrap">{formattedTotalWeight} Kg</Col>
        <Col className="text-secondary no-wrap">
          <FormattedMessage id="general.insurance" defaultMessage="Insurance" />
        </Col>
        <Col>{service.insurance ? "Yes" : "No"}</Col>
        <Col className="text-secondary no-wrap">Stackability</Col>
        <Col>-</Col>
        <Col className="text-secondary no-wrap">Commodity type</Col>
        <Col>-</Col>
      </Row>
    </div>
  );
}

export default QuotesDetailTab;
